import { io } from 'socket.io-client';

/**
 * OOP SocketClient managing connection lifecycle, typed events, and acknowledgment promises.
 */
export class SocketClient {
  constructor(serverUrl = import.meta.env.VITE_SERVER_URL || undefined) {
    this.serverUrl = serverUrl;
    this.socket = null;
  }

  getSocket() {
    if (!this.socket) {
      this.socket = io(this.serverUrl, {
        autoConnect: true,
        withCredentials: true,
        transports: ['websocket', 'polling'],
      });
    }
    return this.socket;
  }

  emitAck(event, payload, timeoutMs = 8000) {
    const s = this.getSocket();
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error(`Socket ack timeout for event "${event}"`)), timeoutMs);
      s.emit(event, payload, (response) => {
        clearTimeout(timer);
        resolve(response);
      });
    });
  }

  on(event, handler) {
    return this.getSocket().on(event, handler);
  }

  off(event, handler) {
    return this.getSocket().off(event, handler);
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export const socketClient = new SocketClient();

export function getSocket() {
  return socketClient.getSocket();
}

export function emitAck(event, payload, timeoutMs = 8000) {
  return socketClient.emitAck(event, payload, timeoutMs);
}
